import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagAI = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M50 25c0 13.807-11.193 25-25 25S0 38.807 0 25C0 25.006 25 .003 25 0c13.807 0 25 11.193 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M24.933 24.999H25v-.067l-.067.067Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 13.043V0h-.004C11.19.002 0 11.194 0 25h13.043v-7.345L20.389 25h4.545l.067-.067V20.39l-7.345-7.345H25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M12.648 3.262a25.119 25.119 0 0 0-9.387 9.387V25h6.521V9.784H25V3.262H12.648Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "m25 21.927-8.882-8.882h-3.074L25 25.001v-3.074Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F3F3F3",
  d: "M42.279 28.659a6.096 6.096 0 0 0 1.199-3.66V14.13a5.41 5.41 0 0 1-3.26 1.088 5.426 5.426 0 0 1-4.349-2.174 5.427 5.427 0 0 1-4.348 2.174 5.411 5.411 0 0 1-3.26-1.087V25c0 1.462.48 2.67 1.199 3.659h12.819Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FF9811",
  d: "M40.019 22.983c.346-.845.615-2.079.615-2.693 0-.987-1.286-1.787-1.286-1.787s-1.287.8-1.287 1.787c0 .614.27 1.848.615 2.693l-.742 1.676a3.746 3.746 0 0 0 2.828 0l-.743-1.676ZM34.99 17.554c-.904.122-2.107.507-2.639.814-.854.493-.904 2.007-.904 2.007s1.336.714 2.19.22c.533-.306 1.466-1.156 2.024-1.878l1.824-.196a3.752 3.752 0 0 0-1.414-2.449l-1.08 1.482ZM32.803 24.623c.557.721 1.492 1.571 2.024 1.878.854.494 2.19-.22 2.19-.22s-.05-1.515-.904-2.008c-.532-.307-1.735-.691-2.64-.813l-1.08-1.482a3.75 3.75 0 0 0-1.414 2.45l1.824.195Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#338AF3",
  d: "M29.19 28.262c2.031 3.258 6.68 4.348 6.68 4.348s4.648-1.09 6.678-4.348H29.191Z"
}));
FlagAI.displayName = 'FlagAI';
export default withFlagWrapper(FlagAI);
//# sourceMappingURL=index.js.map